import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { AutoComplete } from "antd";

const FmanBankDetails = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const redirectBasedOnUseCase = () => {
    const useCase = localStorage.getItem("useCase");

    switch (useCase) {
      case "Procurement":
        navigate("/fmnmis");
        break;

      case "Seed Production":
        navigate("/SeedMIS");
        break;

      case "Agri Promoter":
        navigate("/agrimis");
        break;

      case "Research Program":
        navigate("/researchProgramMIS");
        break;

      default:
        navigate("/fmnmis");
        break;
    }
  };

  const handleButtonClick = () => {
    redirectBasedOnUseCase();
  };

  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [stateName, setStateName] = useState("");
  const [stateData, setStateData] = useState([]);
  const [identificationNumber, setIdentificationNumber] = useState("");
  const [identificationData, setIdentificationData] = useState([]);
  const [showDateFilter, setShowDateFilter] = useState(false);
  const [selectedFromDate, setSelectedFromDate] = useState(
    new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10)
  );
  const [selectedToDate, setSelectedToDate] = useState(
    new Date().toISOString().slice(0, 10)
  );
  const currentDate = new Date().toISOString().slice(0, 10);
  const [data, setData] = useState([]);
  const [fields, setFields] = useState([]);
  const [exportFields, setExportFields] = useState([]);
  const [exportHeaders, setExportHeaders] = useState([]);
  const itemsPerPage = parseInt(localStorage.getItem("pageSize")) || 10;
  const [currentPage, setCurrentPage] = useState(1);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (page) => setCurrentPage(page);

  const { sendRequest: getBankDetailData } = useHttp();
  const { sendRequest: getEmp } = useHttp();
  const { sendRequest: getStateData } = useHttp();
  const { sendRequest: getIdentificationNumber } = useHttp();

  const fillprocurementData = (employeeId, identificationNumber) => {
    let urlfilter = "";
    if (showDateFilter) {
      urlfilter += `&fromDate=${selectedFromDate}&toDate=${selectedToDate}`;
    }
    if (employeeId > 0) urlfilter += `&fieldExecutiveId=${employeeId}`;
    if (identificationNumber)
      urlfilter += `&identificationNo=${identificationNumber}`;
    if (stateName?.trim()) {
      const sanitizedState = stateName.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter += `&stateName=${sanitizedState}`;
    }

    const url = `/api/farmerBankDetailreport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter}`;

    getBankDetailData({ url }, (res) => {
      const resultData = res?.data || [];
      resultData.forEach((item) => {
        if (item.createdDate) item.createdDate = item.createdDate.split(" ")[0];
        if (item.registrationDate)
          item.registrationDate = item.registrationDate.split(" ")[0];
      });
      setData(resultData);
      const activeFields = res?.fields
        ?.filter((f) => f.status === 1)
        ?.sort((a, b) => a.sequenceNo - b.sequenceNo);
      setFields(activeFields);
      setExportFields(activeFields?.map((f) => f.dataField));
      setExportHeaders(activeFields?.map((f) => f.headerField));
    });
  };

  const handleExportExcel = () => {
    const filename = "FarmerBankDetailReport.xlsx";
    const formattedData = data.map((item) => {
      const newItem = { ...item };
      if (newItem.createdDate) {
        newItem.createdDate = newItem.createdDate.split(" ")[0];
      }
      if (newItem.registrationDate) {
        newItem.registrationDate = newItem.registrationDate.split(" ")[0];
      }
      return newItem;
    });

    convertToExcel(formattedData, exportFields, filename, exportHeaders);
  };

  const EmployeeDetail = (state) => {
    let urlfilter = "";
    if (state && state.trim()) {
      const sanitizedState = state.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter += `&stateName=${sanitizedState}`;
    }

    getEmp(
      {
        url: `/api/employeeListForProcReort/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter}`,
      },
      (data) => setEmployeeData(data)
    );
  };

  useEffect(() => {
    EmployeeDetail("");
    getStateData(
      {
        url: `/api/stateLocation/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => setStateData(data)
    );
  }, []);

  useEffect(() => {
    getIdentificationNumber(
      {
        url: `/api/farmerIdentificationlist/?orgId=${localStorage.getItem(
          "orgId"
        )}&fieldExecutiveId=${employeeId}`,
      },
      (data) => setIdentificationData(data)
    );
  }, [employeeId]);

  const handleSearch = (value) => {
    setIdentificationNumber(value);
    setData([]);
  };

  const filteredOptions =
    identificationData &&
    identificationData
      .filter((item) =>
        item.identificationNo
          .toLowerCase()
          .includes(identificationNumber.toLowerCase())
      )
      .map((item) => ({ value: item.identificationNo }));

  return (
    <div className="content-wrapper">
      <div className="row mx-2">
        <div className="col-md-8 mt-3">
          <label className="card-title mx-3">Farmer Bank Detail Report</label>
        </div>
        <div className="col-md-4 text-right mt-3">
          <button
            type="button"
            className="btn btn-tool"
            data-card-widget="remove"
            onClick={handleButtonClick}
          >
            <i className="fas fa-times" />
          </button>
        </div>
      </div>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3">
              <label>State</label>
              <select
                className="form-control"
                value={stateName}
                onChange={(e) => {
                  const sName = e.target.value;
                  setStateName(sName);
                  EmployeeDetail(sName);
                  setData([]);
                  setEmployeeId(0);
                }}
              >
                <option value="">Select</option>
                {stateData?.map((x) => (
                  <option key={x.stateName} value={x.stateName}>
                    {x.stateName}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-3">
              <label>Procurement Officer</label>
              <select
                className="form-control"
                value={employeeId}
                onChange={(e) => {
                  const userid = e.target.value;
                  setEmployeeId(userid);
                  setData([]);
                }}
              >
                <option value="0">Select</option>
                {employeeData?.map((x) => (
                  <option key={x.userId} value={x.userId}>
                    {x.employeeName}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-3">
              <label>Identification Number</label>
              <AutoComplete
                className="form-control"
                value={identificationNumber}
                options={filteredOptions}
                placeholder="Identification Number"
                onChange={handleSearch}
              />
            </div>

            <div className="col-md-3">
              <label>Apply Date Filter</label>
              <select
                className="form-control"
                onChange={(e) => setShowDateFilter(e.target.value === "Yes")}
              >
                <option value="">Select</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>

            {showDateFilter && (
              <>
                <div className="col-md-3">
                  <label>From Date</label>
                  <input
                    type="date"
                    className="form-control"
                    max={currentDate}
                    value={selectedFromDate}
                    onChange={(e) => setSelectedFromDate(e.target.value)}
                  />
                </div>
                <div className="col-md-3">
                  <label>To Date</label>
                  <input
                    type="date"
                    className="form-control"
                    max={currentDate}
                    value={selectedToDate}
                    onChange={(e) => setSelectedToDate(e.target.value)}
                  />
                </div>
              </>
            )}

            <div className="col-md-3 text-right">
              <label>&nbsp;</label>
              <button
                className="form-control btn btn-sm btn-primary"
                onClick={() =>
                  fillprocurementData(employeeId, identificationNumber)
                }
              >
                Submit
              </button>
            </div>
          </div>
        </div>
        <h5>Please select the parameters to get the desired result</h5>
        <hr />
      </section>

      <section className="content">
        <div className="container-fluid">
          {data.length > 0 && (
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
          )}

          <div className="row">
            <div className="col-md-12">
              <div className="card">
                {data.length > 0 ? (
                  <>
                    <div className="card-body" style={{ padding: "0.4rem" }}>
                      <table className="table table-bordered table-responsive text-center table-sm">
                        <thead>
                          <tr className="table-header">
                            {exportHeaders.map((header, index) => (
                              <th key={index}>{header}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems?.map((itm, i) => (
                            <tr key={i} className="tablerowview">
                              {exportFields.map((field, j) => (
                                <td key={j}>
                                  {typeof itm[field] === "string" &&
                                  itm[field].includes(" ")
                                    ? itm[field].split(" ")[0]
                                    : itm[field]}
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="card-footer clearfix">
                      <Pagination
                        totalItems={data.length}
                        itemsPerPage={itemsPerPage}
                        onPageChange={paginate}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                      />
                    </div>
                  </>
                ) : (
                  <p className="text-center">No data available.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FmanBankDetails;
